"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "useForceUpdate", {
  enumerable: true,
  get: function () {
    return _forceUpdate.useForceUpdate;
  }
});
_Object$defineProperty(exports, "useRefReducer", {
  enumerable: true,
  get: function () {
    return _refReducer.useRefReducer;
  }
});
var _forceUpdate = require("./force-update.hook");
var _refReducer = require("./ref-reducer.hook");